import "../style/style-cargando.css";

const cargandoCard = () => {
    return (
        <div className="flex items-center justify-center min-h-[60vh] px-4">
            <div className="text-center">
                {/* Simple loading spinner with shimmer */}
                <div className="relative inline-block mb-6">
                    <div className="w-16 h-16 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
                    <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-blue-400 rounded-full shimmer opacity-50"></div>
                </div>

                {/* Loading message */}
                <p className="text-lg text-gray-600 font-medium">
                    Loading...
                </p>
                <p className="text-sm text-gray-500 mt-2">
                    Please wait, your information is being loaded
                </p>
            </div>
        </div>
    );
}

export default cargandoCard;